__webpack_require__.p = "/wp-content/themes/horizon-apollo/dist/";